import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type SalesDTO = {
    firstName:string
    lastName:string
    password:string;
    email:string;
    img_url:string;
}
type SalesResponse = {
    data: object;
} & ApiError;
export const CreateSalesAccount = (
    data: SalesDTO
): Promise<SalesResponse> => {
    return axios.post("/sales/create", data);
};
